import * as React from "react"
import { graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const About = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="About" />
      <div className="container container-max-md">
        <div className="bio mb-4">
          <StaticImage
            className="bio-avatar d-block mx-auto mw-100"
            layout="fixed"
            formats={["AUTO", "WEBP", "AVIF"]}
            src="../images/onur.jpg"
            width={250}
            height={250}
            quality={95}
            alt="Onur BOZ"
          />
        </div>
        <svg className="mx-auto d-block mb-5" width="105" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247.6 37.6" fill="#d8d9d2"><path d="M0 29.2V.5h3.5v10.3c1.6-1.9 3.7-2.9 6.2-2.9 1.5 0 2.9.3 4 .9s1.9 1.4 2.4 2.5.7 2.6.7 4.6V29h-3.5V16c0-1.8-.4-3-1.1-3.8S10.4 11 9 11c-1 0-2 .3-2.9.8-.9.5-1.6 1.3-2 2.2-.4.9-.6 2.2-.6 3.8v11.3H0zM22.3 4.6v-4h3.5v4h-3.5zm0 24.6V8.4h3.5v20.7h-3.5zM51.2 26c-.8 1-1.8 1.8-2.8 2.4s-2.1.9-3.2.9c-1.2 0-2.3-.3-3.4-1s-2-1.7-2.7-3.1-1-2.9-1-4.6c0-2.1.5-4.1 1.6-6.2 1.1-2.1 2.4-3.6 4-4.7 1.6-1 3.1-1.6 4.6-1.6 1.1 0 2.2.3 3.2.9 1 .6 1.9 1.5 2.7 2.7l.7-3h3.5l-2.8 13.1c-.4 1.8-.6 2.8-.6 3 0 .4.1.7.4.9s.6.4 1 .4c.7 0 1.6-.4 2.7-1.2 1.5-1 2.7-2.4 3.5-4.2s1.3-3.6 1.3-5.4c0-2.2-.6-4.2-1.7-6.1-1.1-1.9-2.8-3.4-5-4.5S52.6 3 49.9 3c-3 0-5.8.7-8.3 2.1s-4.5 3.5-5.9 6.1c-1.4 2.7-2.1 5.5-2.1 8.6 0 3.2.7 5.9 2.1 8.2s3.4 4 6 5.1 5.5 1.7 8.7 1.7c3.4 0 6.3-.6 8.6-1.7s4-2.5 5.2-4.2h3.5c-.7 1.4-1.8 2.8-3.4 4.2s-3.5 2.5-5.8 3.4-4.9 1.2-8 1.2c-2.9 0-5.6-.4-8-1.1s-4.5-1.9-6.2-3.3-3-3.2-3.9-5.1c-1.1-2.5-1.6-5.1-1.6-8 0-3.2.7-6.2 2-9.1 1.6-3.5 3.8-6.2 6.8-8.1S45.9 0 50 0c3.2 0 6.1.7 8.7 2 2.6 1.3 4.6 3.3 6.1 5.9 1.3 2.3 1.9 4.7 1.9 7.3 0 3.8-1.3 7.1-4 10.1-2.4 2.6-5 3.9-7.8 3.9-.9 0-1.6-.1-2.2-.4s-1-.7-1.2-1.2c-.1-.3-.2-.8-.3-1.6zm-9.5-5.3c0 1.8.4 3.2 1.3 4.2s1.8 1.5 2.9 1.5c.7 0 1.5-.2 2.3-.7s1.6-1.1 2.3-1.9 1.3-2 1.8-3.3.7-2.6.7-4c0-1.8-.4-3.1-1.3-4.1s-2-1.5-3.2-1.5c-.8 0-1.6.2-2.4.6-.7.4-1.4 1.1-2.1 2s-1.2 2.1-1.7 3.4-.6 2.7-.6 3.8zM75 29.2h-3.3V.5h3.5v10.2c1.5-1.9 3.4-2.8 5.7-2.8 1.3 0 2.5.3 3.6.8s2.1 1.2 2.8 2.2c.7.9 1.3 2.1 1.7 3.4.4 1.3.6 2.7.6 4.2 0 3.6-.9 6.3-2.6 8.2s-3.9 2.9-6.3 2.9-4.4-1-5.8-3.1v2.7zm-.1-10.6c0 2.5.3 4.3 1 5.4 1.1 1.8 2.6 2.7 4.5 2.7 1.5 0 2.9-.7 4-2s1.7-3.3 1.7-6-.5-4.7-1.6-6-2.4-1.9-3.9-1.9-2.9.7-4 2c-1.1 1.4-1.7 3.3-1.7 5.8zM92.7 18.8c0-3.8 1.1-6.7 3.2-8.5 1.8-1.5 4-2.3 6.5-2.3 2.9 0 5.2.9 7 2.8 1.8 1.9 2.7 4.5 2.7 7.7 0 2.7-.4 4.8-1.2 6.3s-2 2.7-3.5 3.6-3.2 1.3-5 1.3c-2.9 0-5.3-.9-7-2.8s-2.7-4.6-2.7-8.1zm3.6 0c0 2.7.6 4.6 1.7 6s2.6 2 4.4 2c1.7 0 3.2-.7 4.4-2s1.7-3.4 1.7-6.1c0-2.6-.6-4.5-1.7-5.8-1.2-1.3-2.6-2-4.3-2-1.8 0-3.2.7-4.4 2-1.2 1.2-1.8 3.2-1.8 5.9zM114.4 29.2v-2.9l13.2-15.2c-1.5.1-2.8.1-4 .1h-8.5V8.4h17v2.3l-11.2 13.2-2.2 2.4c1.6-.1 3.1-.2 4.4-.2h9.6v3h-18.3zM137.2 29.2v-4h4v4h-4zM151.2 29.2l-6.3-20.7h3.6l3.3 12L153 25c.1-.2.4-1.6 1.1-4.3l3.3-12.1h3.6l3.1 12 1 4 1.2-4 3.6-12h3.4l-6.5 20.7h-3.7l-3.3-12.4-.8-3.5-4.2 16h-3.6zM174.9 18.8c0-3.8 1.1-6.7 3.2-8.5 1.8-1.5 4-2.3 6.5-2.3 2.9 0 5.2.9 7 2.8 1.8 1.9 2.7 4.5 2.7 7.7 0 2.7-.4 4.8-1.2 6.3s-2 2.7-3.5 3.6-3.2 1.3-5 1.3c-2.9 0-5.3-.9-7-2.8s-2.7-4.6-2.7-8.1zm3.6 0c0 2.7.6 4.6 1.7 6s2.6 2 4.4 2c1.7 0 3.2-.7 4.4-2s1.7-3.4 1.7-6.1c0-2.6-.6-4.5-1.7-5.8-1.2-1.3-2.6-2-4.3-2-1.8 0-3.2.7-4.4 2-1.2 1.2-1.8 3.2-1.8 5.9zM198.4 29.2V8.4h3.2v3.1c.8-1.5 1.6-2.4 2.2-2.9s1.4-.7 2.3-.7c1.2 0 2.4.4 3.6 1.1l-1.2 3.3c-.9-.5-1.7-.8-2.6-.8-.8 0-1.5.2-2.1.7-.6.5-1 1.1-1.3 1.9-.4 1.3-.6 2.6-.6 4.1v10.9h-3.5zM211.8 29.2V.5h3.5v16.3l8.3-8.4h4.6l-7.9 7.7 8.7 13h-4.3l-6.9-10.6-2.5 2.4v8.2h-3.5zM230.4 23l3.5-.5c.2 1.4.7 2.5 1.6 3.2s2.1 1.1 3.7 1.1 2.8-.3 3.6-1 1.2-1.4 1.2-2.3c0-.8-.3-1.4-1-1.9-.5-.3-1.7-.7-3.6-1.2-2.6-.7-4.4-1.2-5.4-1.7s-1.8-1.1-2.3-2-.8-1.8-.8-2.8c0-.9.2-1.8.6-2.6.4-.8 1-1.4 1.7-2 .5-.4 1.3-.7 2.2-1 .9-.3 2-.4 3-.4 1.6 0 3.1.2 4.3.7s2.1 1.1 2.7 1.9 1 1.9 1.2 3.2l-3.4.5c-.2-1.1-.6-1.9-1.4-2.5-.7-.6-1.8-.9-3.2-.9-1.6 0-2.8.3-3.5.8-.7.5-1 1.2-1 1.9 0 .5.1.9.4 1.2.3.4.7.7 1.3.9.4.1 1.4.4 3.1.9 2.5.7 4.2 1.2 5.2 1.6s1.8 1 2.3 1.8.8 1.8.8 3-.3 2.3-1 3.3-1.7 1.8-3 2.4-2.7.8-4.4.8c-2.7 0-4.7-.6-6.2-1.7s-1.8-2.5-2.2-4.7z" /></svg>
        <article className="entry">
          <h1 className="h4">
            Hello, I'm Onur. Nice to meet you.
          </h1>
          <p>
            I'm a front-end and client-side web developer. Since my journey as a freelance designer nearly 10 years ago, I have worked remotely for many clients and agencies, tutored beginners, and collaborated with talented people to create digital products on many projects. I also worked as a full-time front-end developer in some agencies and companies.
          </p>
          <p>
            I am keen to create static and interactive web pages using next generation JavaScript frameworks. I am very sensitive to UI & UX and a flat design fan.
          </p>
          <p>
            I think <i>"Successful interaction starts with user experience and ends with design".</i>
          </p>
          <div className="d-flex align-items-center pt-3">
            <Link to="/works" className="d-inline-flex py-2 px-4 bg-700 hover--bg-600 rounded text-white mw-100">My Works</Link>
            <Link to="/products" className="d-inline-flex py-2 px-4 bg-700 hover--bg-600 rounded text-white mw-100 ms-3">My Products</Link>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md">
                <h2 className="h4">Focus Area</h2>
                <ul>
                  <li><abbr title="Git is a free and open source distributed version control system designed to handle everything from small to very large projects with speed and efficiency.">Git</abbr> (<abbr title="GitHub is a web-based storage service for software development projects that use Git as their version control system.">Github</abbr>, <abbr title="Firebase helps you build and run successful apps">Firebase</abbr>, <abbr title="Netlify makes CI/CD, deployment and scaled hosting a commodity and helps enterprises focus on creating great dynamic consumer experiences in a Jamstack world.">Netlify</abbr>)</li>
                  <li><abbr title="HyperText Markup Language">HTML</abbr> 5</li>
                  <li><abbr title="Cascading Style Sheets">CSS</abbr> 3 (<abbr title="Syntactically Awesome Style Sheets">SASS</abbr>, SCSS)</li>
                  <li>CSS Animations & Transitions</li>
                  <li>JavaScript ES5</li>
                  <li><abbr title="JavaScript library">jQuery</abbr></li>
                  <li><abbr title="JavaScript runtime built on Chrome's V8 JavaScript engine.">Node.js</abbr></li>
                  <li><abbr title="The world's most popular front-end open source toolkit with Sass variables and mixins, responsive grid system, extensive prebuilt components and powerful JavaScript plugins.">Bootstrap</abbr> 3.x, 4.x, 5.x</li>
                  <li><abbr title="Cross-browser compatibility is the ability of a website or web application to function across different browsers and degrade gracefully when browser features are absent or lacking.">Cross-browser Compatibility</abbr></li>
                  <li><abbr title="Search Engine Optimization">SEO</abbr> Techniques</li>
                  <li>Page Speed Techniques</li>
                  <li>Page Accessibility</li>
                  <li>Flat Design</li>
                  <li>User Interface Design</li>
                  <li>User Experience Design</li>
                  <li><abbr title="User Experience">UX</abbr> Research & Testing</li>
                  <li>Responsive Design</li>
                  <li>Pixel Perfect Design</li>
                  <li>Vector Based UI Design</li>
                  <li>Mobile First Design</li>
                  <li>Wireframing, Prototyping</li>
                  <li><abbr title="It is a distributed system that uses web protocols and technologies.">REST-ful</abbr> Services</li>
                  <li>Hosting Management</li>
                </ul>
              </div>
              <div className="col-md">
                <h2 className="h4">
                  Bonus Skills
                </h2>
                <ul>
                  <li><abbr title="A JavaScript library for building user interfaces">ReactJS</abbr> Development</li>
                  <li>Back-end Development (<abbr title="Hypertext Preprocessor">PHP</abbr>, <abbr title="A Dependency Manager for PHP">Composer</abbr>, <abbr title="Packagist is the main Composer repository">Packagist</abbr>)</li>
                  <li><abbr title="Most popular in the world website builder">WordPress</abbr> Development</li>
                  <li><abbr title="Content Management System">CMS</abbr> Implementation</li>
                  <li>Tailwindcss</li>
                  <li>Bulma</li>
                  <li>Loadash</li>
                  <li>Illustration Design</li>
                  <li>Print Design</li>
                  <li>Identity Design</li>
                  <li>Motion Design</li>
                </ul>
              </div>
            </div>
          </div>
          <h2 className="h4 mb-0">
            Tools and peripherals in my work environment
          </h2>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h3 className="h5">Mostly</h3>
                <ul>
                  <li>Visual Studio Code</li>
                  <li>Notepad++</li>
                  <li>GitHub Desktop</li>
                  <li>Postman</li>
                  <li>XAMPP</li>
                  <li>WinSCP</li>
                  <li>Figma</li>
                  <li>Adobe Illustrator</li>
                  <li>Adobe After Effects</li>
                  <li>Adobe Photoshop</li>
                  <li>Adobe Premiere</li>
                  <li>Telegram</li>
                  <li>Google Keep</li>
                  <li>Microsoft To Do</li>
                  <li>Slack</li>
                  <li>Alpemix</li>
                  <li>Skype</li>
                  <li>Zoom</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h3 className="h5">Rarely</h3>
                <ul>
                  <li>Sublime Text</li>
                  <li>Sublime Merge</li>
                  <li>Brackets</li>
                  <li>Atom</li>
                  <li>Vim</li>
                  <li>Adobe XD</li>
                  <li>ShareX</li>
                  <li>Koala</li>
                  <li>Typora</li>
                  <li>FontForge</li>
                  <li>Hubstaff</li>
                  <li>Microsoft Teams</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h3 className="h5">Desktop</h3>
                <ul>
                  <li>Intel i5 6500 CPU</li>
                  <li>Asus GTX960-DC GPU</li>
                  <li>MSI B150 M3 Motherboard</li>
                </ul>
                <h3 className="h5">Peripherals</h3>
                <ul>
                  <li>LG 25" 25UM58 Ultra Wide IPS Led Main Monitor</li>
                  <li>Lenovo 21.5" Thinkvision T22I-20 IPS Led Second Monitor</li>
                  <li>Logitech G213 Prodigy Keyboard</li>
                  <li>Logitech G300s Mouse and pad</li>
                  <li>Rampage SN-RMX8 Echo-R USB Microphone</li>
                  <li>Creative SBS A300 2+1 Speaker</li>
                  <li>Anker SoundCore Motion B Bluetooth Speaker</li>
                  <li>Xiaomi Redmi Airdots Tws Bluetooth Headset</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h3 className="h5">Laptop</h3>
                <ul>
                  <li>
                    Samsung NP3530EA
                  </li>
                </ul>
                <h3 className="h5">Tablet</h3>
                <ul>
                  <li>
                    Casper N240 Atom
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </article>
      </div>
    </Layout>
  )
}

export default About

export const pageQuery = graphql`
        query {
          site {
          siteMetadata {
          title
        }
    }
  }
        `